/* eslint-disable */
import Axios from 'axios'
import Qs from 'qs'
import host from './config.js'
export function http(url, data, type) {
  let reqType = type || 'post'
  // let baseurl = 
  
  let config = {
    url: host.Host + url,
    method: reqType,  
  }
  data.activityId = 2;
  if (reqType.toLowerCase() === 'get') {
    config.params = data
  } else {
    config.data = Qs.stringify(data);
    config.headers = {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  }
  return Axios(config);
}


// WEBPACK FOOTER //
// ./src/libs/http.js